<template>
    <div class="sales-promo-page" v-if="salesCard != null" :data-project="salesCard.project_name.slug">
        <div class="promo-page-carousel">
            <swiper :options="swiperOption" ref="promoCarousel">
                <swiper-slide v-for="(slide, index) in salesCard.project_promo_site.promo_gallery" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="promo-carousel-in">
                <div class="container">
                    <div class="promo-header">
                        <div class="promo-logo">
                            <div class="logo">
                                <img :src="salesCard.logo_white">
                            </div>
                            <div class="soon" :data-them="salesCard.project_them.value" :data-part-name="salesCard.new_start_part_name" :data-them-title="salesCard.project_them.label" :data-them-custom="salesCard.custom_theme" :data-name="salesCard.project_name.slug"></div>
                        </div>
                        <div class="promo-right-column" v-if="CityProject != null">
                            <a :href="'tel:' + CityProject.region_phone" class="phone-number">
                                <svg-icon icon-class="phone" className="icon-phone"/>
                                <span>{{CityProject.region_phone}}</span>
                            </a>
                            <a href="#" class="sales-office" 
                                v-scroll-to="{
                                    el: '#section-contacts-sales-promo',
                                    offset: -50
                                }">
                            Офис продаж</a>
                        </div>
                    </div>
                    <div class="promo-title">
                        <h2>{{salesCard.project_title}}</h2>
                    </div>
                    <div class="swiper-controls sales-promo-controls" v-if="salesCard.project_promo_site.promo_gallery != undefined && salesCard.project_promo_site.promo_gallery.length > 1">
                        <div class="container">
                            <div class="sales-promo-btn-prev slider-btn">
                                <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                            </div>
                            <div class="sales-promo-btn-next slider-btn">
                                <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sales-promo-pagination" v-if="salesCard.project_promo_site.promo_gallery != undefined && salesCard.project_promo_site.promo_gallery.length > 1"></div>
                </div>
            </div>
        </div>
        <div class="sales-form-container">
            <formPromo :promoForm="CityProject" v-if="formInit"></formPromo>
        </div>
        <div class="sales-promo-contacts" id="section-contacts-sales-promo">
            <div class="container">
                <div class="section-title">
                    <h2>Офис продаж</h2>
                </div>
                <div class="office-item">
                    <div class="office-info office-adres">
                        <svg-icon icon-class="pin" className="svg-icon icon-pin"/>
                        <div class="info">
                            <strong>{{salesCard.project_promo_site.office_card[0].office_name}}</strong>
                            <p><span v-for="desc in salesCard.project_promo_site.office_card[0].adres">{{desc.desc}}</span></p>
                        </div>
                    </div>
                    <div class="office-info office-phone">
                        <svg-icon icon-class="mobile" className="svg-icon icon-mobile"/>
                        <div class="info">
                            <strong>Контактный телефон:</strong>
                            <!-- <a><a :href="'tel:' + currentCityArr[0].region_phone">{{currentCityArr[0].region_phone}}</a></p> -->
                            <p><a :href="'tel:' + salesCard.project_promo_site.office_card[0].phone_number">{{salesCard.project_promo_site.office_card[0].phone_number}}</a></p>
                        </div>
                    </div>
                    <div class="office-info office-time">
                        <svg-icon icon-class="clock" className="svg-icon icon-clock"/>
                        <div class="info">
                            <strong>Режим работы:</strong>
                            <p v-for="desc in salesCard.project_promo_site.office_card[0].work_time">{{desc.day}}<span class="red">{{desc.time}}</span></p>
                        </div>
                    </div>
                </div>
                <div class="map-container">
                    <div class="map" id='YmapSalesContactsPromo'></div>
                </div>
            </div>
        </div>
        <div class="container">
            <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(cardID) +  ':', data_title: CapitalizeID(cardID) + ' - ' + salesCard.project_title, data_link: 'https://sales.bazis.kz/sales/' + cardID, data_page: 'PROMO - ' + CapitalizeID(cardID), data_page_key: 'sales-promo-page'}]"></sharePostBottom>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import formPromo from '@/components/forms/form-sales-promo.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'
    export default {
        name: 'sale-promo-page',
        components: {
            formPromo,
            sharePostBottom,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
                CityProject: null,
                formInit: false,
                zoom: 12,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-promo-btn-next',
                        prevEl: '.sales-promo-btn-prev',
                    },
                    pagination: {
                        el: '.sales-promo-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            setup: 'loadPageSetUp',
        }),
        methods: {
            filterRegion() {
                if (this.setup != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug === this.salesCard.city_name.slug
                    });
                    this.CityProject = filteredItems[0];
                    this.formInit = true;
                    this.initMapContacts();
                    // console.log(this.CityProject)
                }
                // console.log(this.setup)
                
                // this.$store.commit('CurrentCityArr', filteredItems);
                // this.regionCityArr = filteredItems;
            },
            initMapContacts() {
                const _self = this;
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    if (this.CityProject != null) {
                        var location = this.CityProject;
                        var marker = 'https://sales.bazis.kz/cms/media/2019/12/sales_marker_map_contacts.svg';
                        var zoom = this.zoom;
                        var Ymap;
                        var myPlacemark;
                        ymaps.ready().then(function() {
                            
                            var initMap = function() {
                                Ymap = new ymaps.Map('YmapSalesContactsPromo', {
                                    center: [_self.CityProject.city_map_lng, _self.CityProject.city_map_lat],
                                    zoom: zoom,
                                    controls: ['fullscreenControl'],
                                    behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                                },{suppressMapOpenBlock: true, minZoom: 12, maxZoom: 18});
                                Ymap.controls.add('zoomControl', {position: {right: '10px', top: '180px'}});
                            };

                            var buildPinsOnMap = function() {
                                var lat = _self.salesCard.project_promo_site.office_card[0].office_map_lat,
                                    lng = _self.salesCard.project_promo_site.office_card[0].office_map_lng;
                                myPlacemark = new ymaps.Placemark([lng,lat], {}, {
                                    iconLayout: 'default#image',
                                    iconImageHref: marker,
                                    iconImageSize: [80, 90],
                                    iconImageOffset: [-20, -50]
                                })

                                Ymap.geoObjects.add(myPlacemark);
                                Ymap.setCenter([lng, lat]);
                            };

                            initMap();
                            buildPinsOnMap();
                        });
                    }
                })
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            }
        },
        beforeCreate() {
        },
        created () {
            // this.getDataCard();
            document.body.dataset.page = 'sales-promo-page';
        },
        mounted () {
            this.filterRegion();
            // this.shortSalesBaners();
            // this.shortSalesItemsForBanerSystem();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    this.filterRegion();
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-promo.scss';
    @import '@/styles/respond/sales/sales-promo-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>